var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgManageDevice = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2033 0.941406H5.21954C4.23133 0.941406 3.4228 1.74994 3.4228 2.73815V5.43326H5.21954V3.63652H14.2033V18.0105H5.21954V16.2137H3.4228V18.9088C3.4228 19.897 4.23133 20.7056 5.21954 20.7056H14.2033C15.1915 20.7056 16 19.897 16 18.9088V2.73815C16 1.74994 15.1915 0.941406 14.2033 0.941406ZM3.43178 12.1441L1.14093 9.85325L0 10.9942L3.4228 14.417L9.88209 7.95769L8.74116 6.81676L3.43178 12.1441Z",
    fill: "#03002F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43178 12.1438L1.14093 9.8529L0 10.9938L3.4228 14.4166L9.88209 7.95734L8.74116 6.81641L3.43178 12.1438Z",
    fill: "#DDE2EB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgManageDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manageDevice.3c1cc5e534b2ef9004059a4f0d10bcea.svg";